import { LabelValue } from '@dxb-web-ui-framework/design-system';
import { useCountdownCounter } from '@dxb-web-ui-framework/common/hooks';
import React, { VFC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export interface DealerRateCounterProps {
  isLoading: boolean;
  timer: number;
  onDealerRateExpiration: Function;
}

const DealerRateCounter: VFC<DealerRateCounterProps> = ({ isLoading, timer, onDealerRateExpiration }) => {
  const { t } = useTranslation();
  const { countdownCounter, isCounting } = useCountdownCounter(timer, undefined, onDealerRateExpiration);

  const minutes = Math.floor(countdownCounter / 60);
  const seconds = countdownCounter - minutes * 60;
  const secondsToDisplay = String(seconds).length === 1 ? `0${seconds}` : seconds;
  const value = isCounting ? `${minutes}:${secondsToDisplay}` : '00:00';

  useEffect(() => {
    if (timer === 0 || timer < 0) {
      onDealerRateExpiration();
    }
  }, [timer, onDealerRateExpiration]);

  return (
    <LabelValue
      label={t('consolidatedTransactionsDetailsPage.DealerRateCounter.Expiration')}
      value={value}
      valueAreaLabel={`${t('consolidatedTransactionsDetailsPage.DealerRateCounter.Expiration')} ${value}`}
      labelColor='textPrimary'
      labelSize='small'
      valueSize='small'
      valueColor='secondary'
      labelAlignment='left'
      valueAlignment='left'
      hasSkeleton={isLoading}
    />
  );
};

export { DealerRateCounter };
